import { BsBox2Fill } from "react-icons/bs";
import { MdDelete } from "react-icons/md";

const AddedProducts = ({ products, handleDelete, isDisabled = false }) => {
  if (products.length === 0) return null; // Early return for better readability

  return (
    <div className="h-fit w-full flex flex-col gap-4 bg-background_2/80 rounded-2xl p-4">
      {/* Header Section */}
      <div className="w-full flex gap-2 items-center">
        <BsBox2Fill className="text-headline4 text-secondary/80" />
        <h2 className="text-headline4 text-secondary/80 font-nunito font-semibold">
          Added Products
        </h2>
      </div>

      {/* Scrollable Table Container */}
      <div className="w-full overflow-auto">
        <table className="w-full min-w-max border-collapse overflow-hidden">
          <thead className="text-subtitle2 text-secondary/90 font-nunito font-bold">
            <tr>
              <th className="text-left px-2 py-1">Product Name</th>
              <th className="text-left px-2 py-1">Quantity</th>
              <th className="text-left px-2 py-1">Order Value</th>
              <th className="text-left px-2 py-1">HSN No.</th>
              <th className="text-left px-2 py-1">SKU No.</th>
              <th className="text-left px-2 py-1">Action</th>
            </tr>
          </thead>
          <tbody>
            {products
              .slice() // Creates a shallow copy to prevent mutating state
              .reverse() // Displays the latest product first
              .map((product, index) => (
                <tr className="text-secondary/55" key={index}>
                  <td className="px-2 py-1">{product.productName}</td>
                  <td className="px-2 py-1">{product.quantity}</td>
                  <td className="px-2 py-1">{product.orderValue}</td>
                  <td className="px-2 py-1">{product.hsn || "---"}</td>
                  <td className="px-2 py-1">{product.sku || "---"}</td>
                  <td className="px-2 py-1">
                    <button
                      onClick={() => handleDelete(index)}
                      disabled={isDisabled}
                      className={`p-1.5 rounded-lg bg-[#FF5C5F]/15 hover:bg-[#FF5C5F]/30 transition ${
                        isDisabled && "cursor-not-allowed opacity-60"
                      }`}
                    >
                      <MdDelete className="text-red-600 text-lg" />
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddedProducts;
